import { Tabs } from 'antd';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)`
  &&&& {
    .ant-tabs-nav {
      margin-bottom: 0px;

      ::before {
        display: none;
      }
    }

    .ant-tabs-nav-list {
      width: 100%;
      display: grid;
      grid-template-areas: 'predefined' 'custom';
      column-gap: 4px;
      grid-template-columns: 1fr 1fr;

      ::before {
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        border-bottom: 1px solid #f0f0f0;
        content: '';
      }

      .ant-tabs-tab {
        margin: 0%;
        .ant-tabs-tab-btn {
          width: 100%;
          text-align: center;

          :focus-visible {
            border: 1px solid black;
          }
        }
      }

      .ant-tabs-tab:nth-child(1) {
        grid-area: 'predefined';
      }

      .ant-tabs-tab:nth-child(2) {
        grid-area: 'custom';
      }

      .ant-tabs-ink-bar {
        width: 50%;
      }
    }
  }
`;
